import { defineComponent as t, createBlock as a, openBlock as o, withCtx as r, createElementVNode as s, renderSlot as n, createTextVNode as p, toDisplayString as l } from "vue";
import c from "./DataTableCell.vue.js";
const i = { class: "flex-1 px-2 py-1.5 whitespace-nowrap" }, x = /* @__PURE__ */ t({
  __name: "DataTableText",
  props: {
    text: {}
  },
  setup(_) {
    return (e, f) => (o(), a(c, { class: "relative flex" }, {
      default: r(() => [
        s("span", i, [
          n(e.$slots, "default", {}, () => [
            p(l(e.text), 1)
          ])
        ])
      ]),
      _: 3
    }));
  }
});
export {
  x as default
};
